<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <!-- Header con Filtros y Acciones -->
          <OrderOutBoxQueueListTableHeader
            :title="$t('key_order_outbox_queue_list_table_title')"
            :description="$t('key_order_outbox_queue_list_table_description')"
            :enable-reload="true"
            :enable-search="true"
            :selected-ids="selectedIds"
            :list-filters="filters"
            @search-change="searchChange"
            @reload-page="reloadPage"
            @order-outbox-queue-action-filter-change="orderOutboxQueueActionFilterChange"
            @order-outbox-queue-status-filter-change="orderOutboxQueueStatusFilterChange"
            @clear-all-filters="clearAllFilters">  <!-- TODO: Pendiente de calibrar los componentes por las preferencias del usuario --> 
          </OrderOutBoxQueueListTableHeader>
          
          <!-- Tabla con los Datos -->
          <GenericTableV2
            ref="genericTable"
            :items="integrationsAlierSGAOrderOutboxQueueData?.data?.items"
            :pagination="pagination"
            :headers="headers"
            :selected-ids="selectedIds"
            :is-loading="isLoading"
            @changed-header="onChangeHeader"
            @changed-page="paginationPageChange"
            @changed-row="paginationRowChange"
            @changed-selection="changedSelection">
            <template #row="{item}">
              <td style="width: 20rem" class="text-xs cursor-pointer font-weight-bolder mb-0 picko-link">
                <div class="d-flex">
                  <div class="my-auto form-check">
                    <input :id="item.id" class="form-check-input" type="checkbox" :checked="selectedIds.includes(item.id)" @change="changedSelection(item.id)" >
                  </div>
                  <a class="my-auto ms-3 picko">
                    <a class="font-weight-bold text-primary" href="#" @click.prevent="openMessageDetails(item.id)">
                      {{ item.id }}
                    </a>
                  </a>
                </div>
              </td>
              <td style="width: 10rem" class="text-xs font-weight-bolder">
                <span v-if="item.action=='POST'" class="badge badge-actionpost">{{ item.action }}</span>
                <span v-else-if="item.action=='DELETE'" class="badge badge-actiondelete">{{ item.action }}</span>
              </td>
              <td style="width: 20rem" class="text-xs font-weight-bolder">
                <a>{{ item.correlation_id }}</a>
              </td>
              <td style="width: 20rem" class="text-xs font-weight-bolder">
                <a>{{ item.payload.brand }}</a>
              </td>
              <td style="width: 20rem" class="text-xs font-weight-bolder">
                <a :title="item.payload.number">{{ $stringUtils.truncate(item.payload.number) }}</a>
              </td>
              <td style="width: 20rem" class="text-xs font-weight-bolder">
                <a>{{ $dateUtils.toDDMMYYYYHH(item.date) }}</a>
              </td>
              <td style="width: 20rem" class="text-xs font-weight-bolder">
                <span v-if="item.status=='PENDING'" class="badge badge-statuspending"><i class="fa-solid fa-hourglass-start me-1"></i>{{ $t('key_status_penging') }}</span>
                <span v-else-if="item.status=='SENDED'" class="badge badge-statussended"><i class="fa-solid fa-paper-plane me-1"></i>{{ $t('key_status_sended') }}</span>
                <span v-else-if="item.status=='CONFIG_ERROR'" class="badge badge-statusconfigerror"><i class="fa-solid fa-triangle-exclamation me-1"></i>{{ $t('key_status_config_error') }}</span>
                <span v-else-if="item.status=='INVALID'" class="badge badge-statusinvalid"><i class="fa-solid fa-bug me-1"></i>{{ $t('key_status_invalid') }}</span>
                <span v-else-if="item.status=='ERROR'" class="badge badge-statuserror"><i class="fa-solid fa-xmark me-1"></i>{{ $t('key_status_error') }}</span>
                <span v-else-if="item.status=='DEAD'" class="badge badge-statusdead"><i class="fa-solid fa-skull-crossbones me-1"></i>{{ $t('key_status_dead') }}</span>
              </td>
              <td style="width: 20rem" class="text-xs font-weight-bolder">
                <a>{{ item.attempts }}</a>
              </td>
              <td style="width: 20rem" class="text-xs font-weight-bolder">
                <Button v-if="!item.last_error" color="success" variant="outline"
                  class="btn-icon-only btn-rounded mb-0 me-2 btn-sm d-flex align-items-center justify-content-center">
                  <i class="fa-solid fa-check" aria-hidden="true"></i>
                </Button>
                <Button v-else-if="item.last_error" color="danger" variant="outline"
                  class="btn-icon-only btn-rounded mb-0 me-2 btn-sm d-flex align-items-center justify-content-center"
                  :title="item.last_error">
                  <i class="fa-solid fa-exclamation" aria-hidden="true"></i>
                </Button>
              </td>
              <td style="width: 20rem" class="text-xs font-weight-bolder">
                <a v-if="item.status!='SENDED'">{{ $dateUtils.toDDMMYYYYHH(item.next_attempt_at) }}</a>
              </td>
              <td style="width: 20rem" class="text-xs font-weight-bolder">
                <a>{{ $dateUtils.toDDMMYYYYHH(item.sent_at) }}</a>
              </td>
            </template>
          </GenericTableV2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import { mapState, mapActions } from "vuex";
  import Button from "./../../../../../../generic_components/Button.vue";
  import OrderOutBoxQueueListTableHeader from "./../../components/OrderOutboxQueueListTableHeader.vue";
  import GenericTableV2 from "./../../../../../../generic_components/GenericTableV2.vue";

  export default {
    name: "OrderOutBoxQueueList",
    components: {
      Button,
      GenericTableV2,
      OrderOutBoxQueueListTableHeader,
    },
    data() {
      return{
        myAccount: JSON.parse(localStorage.getItem("user")),
        filters: {
          search: '',
          status: '',
          sort: {
            sort: '',
            order: ''
          },
          action: '',
        },
        isLoading: false,
        pagination: {
          total: 0,
          rows: 10,
          currentPage: 1,
          pages: {
            total: 10,
            current: 1
          },
          entries: [5, 10, 15, 20, 50, 100, 200],
        },
        selectedIds: [],
      }
    },
    computed: {
      ...mapState('integrationsAlierSGAOrderOutboxQueueAdmin', {
        integrationsAlierSGAOrderOutboxQueueData: state => state.list.data,
        integrationsAlierSGAOrderOutboxQueueResponse: state => state.list.response,
        integrationsAlierSGAOrderOutboxQueueStatus: state => state.list.status,
      }),
      listFilters() {
        return this.$store.state.integrationsAlierSGAOrderOutboxQueueAdmin.listFilters;
      },
      headers() {
        return [
          { title: this.$t('key_theader_id'), sort: { sorteable: true, order: "" }, column: "_id" },
          { title: this.$t('key_theader_action'), sort: { sorteable: true, order: "" }, column: "action" },
          { title: this.$t('key_theader_correlation_id'), sort: { sorteable: true, order: "" }, column: "correlation_id" },
          { title: this.$t('key_theader_brand'), sort: { sorteable: true, order: "" }, column: "brand" },
          { title: this.$t('key_theader_order_number'), sort: { sorteable: true, order: "" }, column: "payload.number" },
          { title: this.$t('key_theader_message_date'), sort: { sorteable: true, order: "" }, column: "date" },
          { title: this.$t('key_theader_status'), sort: { sorteable: true, order: "" }, column: "status" },
          { title: this.$t('key_theader_attempts'), sort: { sorteable: true, order: "" }, column: "attempts" },
          { title: this.$t('key_theader_last_error'), sort: { sorteable: true, order: "" }, column: "last_error" },
          { title: this.$t('key_theader_next_attempt'), sort: { sorteable: true, order: "" }, column: "next_attempt" },
          { title: this.$t('key_theader_sent_at'), sort: { sorteable: true, order: "" }, column: "sent_at" },
        ]
      }
    },
    watch: {
      integrationsAlierSGAOrderOutboxQueueResponse() {
        if(this.integrationsAlierSGAOrderOutboxQueueData) {

          this.pagination.total = this.integrationsAlierSGAOrderOutboxQueueData.data.pagination.total;
          this.isLoading = false;
        }
      }
    },
    mounted() {
      this.setUpFilters();
      if (Object.keys(this.$route.query).length > 0) {
        this.filters.status = this.$route.query.status;
      }
      this.getOrderOutboxQueueList();
    },
    methods: {
      ...mapActions('integrationsAlierSGAOrderOutboxQueueAdmin',  [
                                                                    'getOrderOutboxQueue'
                                                                  ]),
      setUpFilters() {
        if (Object.keys(this.listFilters).length == 0) {
          return
        }
        this.filters = { ...JSON.parse(JSON.stringify(this.listFilters['filters'])) }
        this.pagination = { ...JSON.parse(JSON.stringify(this.listFilters.pagination)) }
        this.headers = this.headers.map(header => {
          let newHeader = { ...header }

          if (this.filters.sort.sort == header.column) {
            newHeader.sort.order = this.filters.sort.order == 'descending' ? 'desc' : 'asc'
          }

          return newHeader
        })
      },
      async getOrderOutboxQueueList() {
        if (this.integrationsAlierSGAOrderOutboxQueueStatus === 'loading' || this.isLoading) {
          return;
        }
        
        this.isLoading = true;
        try {
          
          await this.getOrderOutboxQueue({filters: this.filters, pagination: this.pagination});
          
          if (this.integrationsAlierSGAOrderOutboxQueueStatus === 'success' && this.integrationsAlierSGAOrderOutboxQueueData.status_code === 200 && this.myAccount.notifications) {
            this.$notify({
              title: this.$t('key_header_successful_retrieving_data'),
              message: this.$t('key_message_successful_retrieving_data'),
              icon: { component: 'fa-solid fa-check', color: 'white' },
              color: 'success',
              show: true,
              duration: 5000
            });
          } else if(this.integrationsAlierSGAOrderOutboxQueueStatus !== 'success') {
            this.$notify({
              title: this.$t('key_header_error_retrieving_data'),
              message: this.$t('key_message_error_retrieving_data'),
              icon: { component: 'fa-solid fa-xmark', color: 'white' },
              color: 'danger',
              show: true,
              duration: 5000
            });
          }
        } catch (error) {
          this.$notify({
            title: this.$t('key_header_error_unexpected'),
            message: this.$t('key_message_error_unexpected'),
            icon: { component: 'fa-solid fa-xmark', color: 'white' },
            color: 'danger',
            show: true,
            duration: 5000
          });
        } finally {
          this.isLoading = false;
        }
      },
      changedSelection(id) {
        if (this.selectedIds.includes(id)) {
          this.selectedIds = this.selectedIds.filter(itemId => itemId !== id);
        } else {
          this.selectedIds.push(id);
        }
      },
      clearSelection() {
        this.selectedIds = [];
      },
      async clearAllFilters() {
        this.filters.action = '';
        this.filters.search = '';
        this.filters.status = '';
        this.clearSelection();
        this.pagination.currentPage = 1;
        this.$notify({
          title: this.$t('key_header_filters_cleared'),
          message: this.$t('key_message_filters_cleared'),
          icon: { component: 'fa-solid fa-eraser', color: 'white' },
          color: 'info',
          show: true,
          duration: 2500
        });
        await this.getOrderOutboxQueueList();
      },
      async searchChange(value) {
        this.clearSelection();
        this.pagination.currentPage = 1;
        this.filters.search = value;
        await this.getOrderOutboxQueueList();
      },
      async reloadPage() {
        await this.getOrderOutboxQueueList();
      },
      async orderOutboxQueueActionFilterChange(val) {
        this.clearSelection();
        this.pagination.currentPage = 1;
        this.filters.action = val;
        console.log(val)
        console.log(this.filters.action)
        await this.getOrderOutboxQueueList();
      },
      async orderOutboxQueueStatusFilterChange(val) {
        this.clearSelection();
        this.pagination.currentPage = 1;
        this.filters.status = val;
        await this.getOrderOutboxQueueList();
      },
      async onChangeHeader(val) {
        this.filters.sort = {
          sort: val.column,
          order: val.order == "asc" ? "ascending" : "descending",
        }
        await this.getOrderOutboxQueueList();
      },
      async paginationPageChange(page) {
        this.pagination.currentPage = page;
        await this.getOrderOutboxQueueList();
      },
      async paginationRowChange(rows) {
        this.pagination.rows = rows;
        await this.getOrderOutboxQueueList();
      },
      openMessageDetails(id) {
        const route = id;
        return route;
      }
    }
  };

</script>
